import { Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

export const StyledPageLayout = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflowX: 'hidden',
}));

interface StyledPageLayoutContentProps {
  verticalpadding?: number;
  horizontalpadding?: number;
}

export const StyledPageLayoutContent = styled(Box)(
  ({ verticalpadding = 0, horizontalpadding = 0 }: StyledPageLayoutContentProps) => {
    const theme = useTheme();
    return {
      padding: theme.spacing(verticalpadding, horizontalpadding),
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'hidden',
      overflowY: 'auto',
    };
  }
);
